module.exports = __webpack_public_path__ + "img/season.521d5a29.png";